/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#save
 *
 * @return {WPElement} Element to render.
 */
export default function save({attributes}) {
    const { selectedElement, textContent, textareaContent, selectOptions, radioOptions, checkOptions, elementLabel, elementID } = attributes;

        if (selectedElement === 'text') {
          return(
            <div class="momo-form-element-block" data-type={selectedElement}>
                <label>{elementLabel}</label>
                <div><input type="text" name={elementID} placeholder={textContent} data-label={elementLabel}/></div>
            </div>
          );
        }
        if (selectedElement === 'textarea') {
          return(
            <div class="momo-form-element-block" data-type={selectedElement}>
                <label>{elementLabel}</label>
                <div><textarea name={elementID} placeholder={textareaContent} data-label={elementLabel}></textarea></div>
            </div>
          );
        }
        if (selectedElement === 'select') {
          return (
            <div class="momo-form-element-block" data-type={selectedElement}>
                <label>{elementLabel}</label>
                <select name={elementID} data-label={elementLabel}>
                    {selectOptions.map((option, index) => (
                    <option key={`select-option-${index}`} value={option.label} >
                        {option.label}
                    </option>
                    ))}
                </select>
            </div>
          );
        }
    
        if (selectedElement === 'radio') {
          return (
            <div class="momo-form-element-block" data-type={selectedElement}>
                <label>{elementLabel}</label>
                {radioOptions.map((option, index) => (
                <div><input type="radio" name={elementID} id={`radio-option-${index}`} value={option.label} data-label={elementLabel}/>
                <label class="momo-radio-label">{option.label}</label>
                </div>          
                ))}
            </div>
          );
        }
        if (selectedElement === 'checkbox') {
          return (
            <div class="momo-form-element-block" data-type={selectedElement}>
                <label>{elementLabel}</label>
                {checkOptions.map((option, index) => (
                <div><input type="checkbox" name={elementID} id={`check-option-${index}`} value={option.label} data-label={elementLabel}/>
                <label class="momo-checkbox-label">{option.label}</label>
                </div>          
                ))}
            </div>
          );
        }
    
        return null;
}